<template>
  <v-container
    fluid
    class="player-status-reports-list"
    style="width: 100%, max-height: 100vh">
    <v-layout
      column
      justify-center
      style="width: 100%, max-height: 100vh"
      v-if="reportsToDisplay && reportsToDisplay.length > 0">
      <div
        class="report-row mb-3"
        v-for="(report, key) in reportsToDisplay"
        :key="`${userId}-${key}`">
        <v-layout column v-if="report">
          <v-layout class="report-mood table">
            <span class="table-cell-no-border player-status-report-date">
              <img
                class="report-check"
                :src="
                  isSubmittedToday(report.date)
                    ? constants.icons.greenCheck
                    : constants.icons.redX
                "
                alt="" />
              {{ formatDate(report.date) }}
            </span>
            <img :src="moodIcon(report)" class="table-cell-no-border" />
          </v-layout>
          <v-layout
            class="row mb-3"
            :set="(difference = calculateReportsDiff(key))">
            <v-layout column justify-center class="table-cell">
              <span class="stats-text">
                Soreness
                <soreness-area
                  v-if="report.selectedSoreness"
                  :soreness-area="report.selectedSoreness"
                  :soreness-description="`${report.selectedSoreness} ${report.sorenessSide}`"></soreness-area>
              </span>
              <div
                v-if="!viewDiff"
                class="report-value"
                :style="[
                  getColor(report.soreness),
                  getBorderColor(difference.soreness.value),
                ]">
                {{ report.soreness }}
              </div>
              <div
                v-else
                class="report-value diff"
                :style="getBorderColor(difference.soreness.value)">
                <!-- :class="difference.soreness.cssClass" -->
                {{ Math.abs(difference.soreness.value) }}
              </div>
            </v-layout>
            <v-layout column justify-center class="table-cell">
              <span class="stats-text">Fatigue</span>
              <div
                v-if="!viewDiff"
                class="report-value"
                :style="[
                  getColor(report.fatigue),
                  getBorderColor(difference.fatigue.value),
                ]">
                {{ report.fatigue }}
              </div>
              <div
                v-else
                class="report-value diff"
                :style="getBorderColor(difference.fatigue.value)">
                <!-- :class="difference.fatigue.cssClass" -->
                {{ Math.abs(difference.fatigue.value) }}
              </div>
            </v-layout>
            <v-layout column justify-center class="table-cell">
              <span class="stats-text">Stress</span>
              <span
                v-if="!viewDiff"
                class="report-value"
                :style="[
                  getColor(report.stress),
                  getBorderColor(difference.stress.value),
                ]">
                {{ report.stress }}
              </span>
              <div
                v-else
                class="report-value diff"
                :style="getBorderColor(difference.stress.value)">
                <!-- :class="difference.stress.cssClass" -->
                {{ Math.abs(difference.stress.value) }}
              </div>
            </v-layout>
            <v-layout column justify-center class="table-cell">
              <span class="stats-text">Sleep</span>
              <span
                v-if="!viewDiff"
                class="report-value"
                :style="[
                  getColor(report.sleep),
                  getBorderColor(difference.sleep.value),
                ]">
                {{ report.sleep }}
              </span>
              <div
                v-else
                class="report-value diff"
                :style="getBorderColor(difference.sleep.value)">
                <!-- :class="difference.sleep.cssClass" -->
                {{ Math.abs(difference.sleep.value) }}
              </div>
            </v-layout>
          </v-layout>
        </v-layout>
      </div>
      <!-- <infinite-loading
        v-if="viewAll"
        @infinite="infiniteHandler"
        :identifier="user.id"
        spinner="spiral">
        <div slot="no-more">No more reports</div>
        <div slot="no-results">No reports</div> 
 </infinite-loading> -->
    </v-layout>
    <div id="sentinel"></div>
  </v-container>
</template>

<script>
import constants from "@/constants.js"
import SorenessArea from "@/components/shared/common/SorenessArea.vue"
// import { mapState } from "vuex"
import { getPagedUserReports } from "@/api/firebase.api.js"

export default {
  name: "ReportContent",
  components: { SorenessArea },
  props: ["viewDiff", "viewAll", "userId"],
  data() {
    return {
      observer: null,
      lastKey: null,
      currentReport: null,
      months: constants.months,
      icons: constants.icons,
      constants,
    }
  },

  async mounted() {
    // await this.getReports()
    await this.observerSentinel()
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },

  computed: {
    // ...mapState("reports", {
    //   reports: (state) => state.playerReports[this.$props.userId],
    // }),
    reports: {
      get: function () {
        if (
          this.$store.state.reports.playerReports[this.$props.userId] ===
          undefined
        ) {
          return []
        }
        return this.$store.state.reports.playerReports[this.$props.userId]
      },
      set: function (value) {
        this.$store.commit("reports/addPlayerReports", {
          userId: this.$props.userId,
          playerReports: value,
        })
      },
    },
    reportsToDisplay() {
      return !this.viewAll ? this.reports.slice(0, 1) : this.reports
    },
    // userId() {
    //   console.log("userid", this.$props.userId)
    //   return this.$route.params?.id ?? this.$props.userId
    // },
  },

  methods: {
    async getReports() {
      if (!this.isLast) {
        const data = await getPagedUserReports({
          userId: this.userId,
          limit: null,
          referenceToOldestKey: this.lastKey,
        })
        if (data.reports.length === 0) {
          this.$toast.info("No reports available")
        } else {
          const additionalReports = data.reports.filter((report) => {
            if (!this.reports.find((r) => r.id === report.id)) {
              return report
            } else {
              return false
            }
          })
          const newReports = this.reports.concat(additionalReports)
          const sorted = newReports.sort((a, b) => a.timeStamp - b.timeStamp)
          this.reports = sorted
        }
        this.lastKey = data.lastKey
        this.isLast = data.isLast
      }
    },

    async observerSentinel() {
      const options = {
        root: null,
        threshold: 0.3,
      }
      this.observer = new IntersectionObserver(async (entries) => {
        entries.forEach(async (e) => {
          if (e.isIntersecting) {
            await this.getReports()
          }
        })
      }, options)
      const sentinel = document.getElementById("sentinel")
      if (sentinel) {
        this.observer.observe(sentinel)
      }
    },
    buildDiffData(value) {
      const cssClass = value > 0 ? "green" : value < 0 ? "red" : "neutral"
      return {
        value,
        cssClass,
      }
    },

    calculateReportsDiff(reportIndex) {
      const reportA = this.reports[reportIndex]
      if (this.reports.length > reportIndex + 1) {
        const reportB = this.reports[reportIndex + 1]
        const sorenessDiff = reportB.soreness - reportA.soreness
        const fatigueDiff = reportB.fatigue - reportA.fatigue
        const stressDiff = reportB.stress - reportA.stress
        const sleepDiff = reportB.sleep - reportA.sleep
        return {
          soreness: this.buildDiffData(sorenessDiff),
          fatigue: this.buildDiffData(fatigueDiff),
          stress: this.buildDiffData(stressDiff),
          sleep: this.buildDiffData(sleepDiff),
        }
      } else {
        this.$emit("cannotCompareReports")
      }
      return {
        soreness: { value: 0, cssClass: "white" },
        fatigue: { value: 0, cssClass: "white" },
        stress: { value: 0, cssClass: "white" },
        sleep: { value: 0, cssClass: "white" },
      }
    },

    formatDate(date) {
      if (this.isSubmittedToday(date)) {
        return "Today"
      }
      return this.$moment(date).format("D MMM YYYY")
    },

    getBorderColor(value) {
      if (value !== undefined) {
        const borderColor =
          value > 0 ? "rgba(40,247,71,1)" : value < 0 ? "red" : "#5B657D"
        return { border: "5px solid " + borderColor }
      }
      return { border: "5px solid #5B657D" }
    },

    getColor(value) {
      return {
        color: value >= 8 ? "red" : value >= 5 ? "orange" : "rgba(40,247,71,1)",
      }
    },

    isSubmittedToday(date) {
      return date.format("YYYYMMDD") === this.$moment().format("YYYYMMDD")
    },

    moodIcon(report) {
      const mood = report.mood
      return mood <= 3
        ? this.icons.happy
        : mood <= 7
        ? this.icons.neutral
        : this.icons.sad
    },

    infiniteHandler($state) {
      this.$emit("fetch", $state)
    },
  },
}
</script>

<style lang="sass">
@import '@/assets/sass/_variables.sass'
.player-status-reports-list
  .report-row
    .diff
      border: 5px solid transparent

      &.green:before
        content: '-'

      &.red:before
        content: '+'

    .report-mood
      // width: 100%

      // span
      //   width: 10%

      img
        width: 40px
        height: 40px
        margin-bottom: 5px
        float: right

      .report-check
        float: none
        width: 15px
        height: auto
        vertical-align: middle
        margin-bottom: auto

    .row
      width: 100%

      .table-cell
        margin: 1.5rem 0 0 0
        // width: 25%
        display: flex
        align-items: center
        text-align: center
        // height: 100px
        // margin-right: 2px

        .stats-text
          text-overflow: ellipsis
          overflow: hidden
          margin-bottom: 2%
          font-size: 1.2em

        .report-value
          font-weight: bold
          font-size: 1.3em
          width: 70px
          height: 70px
          border-radius: 50%
          display: table-cell
          text-align: center
          padding: 15px 0
          background-color: #3c444c

    .table
      width: 97%
      display: table
      margin-top: 0.5rem
      margin-bottom: -1rem

      .table-cell-no-border
        display: table-cell
        vertical-align: middle
        text-align: center
        height: 40px

      .player-status-report-date
        text-align: left
        vertical-align: top
        font-weight: 300
@media print
  .player-status-reports-list
    .report-row
      > .layout.column
        flex-direction: row

      .table
        display: inline-block
        text-align: right

        .table-cell-no-border
          display: inline-block
          height: auto
          margin-left: 30px

      .report-mood
        margin-left: 0
        width: auto
        order: 3

        .player-status-report-date
          text-align: left

        > img
          margin: 5px auto 0 !important
          width: 20px
          height: 20px !important

      .row .table-cell
        height: auto

        .stats-text
          font-size: 1em

        .report-value
          border-width: 2px !important
          height: 26px
          line-height: 22px
          padding: 0
          vertical-align: middle
          width: 26px
  .mb-3
    margin-bottom: 0 !important
</style>
